import axios from "axios";
import { BrowseSearchFilters } from "../../api-types/job-requests/common";
import { SEARCH_PROFESSIONALS_URL } from "../utils";

export const searchProfessionals = async (filter: BrowseSearchFilters) => {
  return axios.post(SEARCH_PROFESSIONALS_URL, {
    ...filter,
  });
};
